import { render, staticRenderFns } from "./forkliftDriver.vue?vue&type=template&id=c7bc2dca"
import script from "./forkliftDriver.vue?vue&type=script&lang=js"
export * from "./forkliftDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7bc2dca')) {
      api.createRecord('c7bc2dca', component.options)
    } else {
      api.reload('c7bc2dca', component.options)
    }
    module.hot.accept("./forkliftDriver.vue?vue&type=template&id=c7bc2dca", function () {
      api.rerender('c7bc2dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/report/warehouse/forkliftDriver.vue"
export default component.exports